import { createPatternBatch, patternBatchValue } from './_batch';
import * as common from './_common';
import { formatPatternConstant } from './_constant';
import { createPatternDocument, patternDocumentValue } from './_document';
import { createPatternGlobal, patternGlobalValue } from './_global';
import * as patternType from './_pattern-type';

export { DOCUMENT_PATH_BATCH_PREFIX } from './_path';

/** Pattern logic. */
const patternLogic = {
  ...common,
  formatPatternConstant,

  patternType,

  global: {
    patternValue: patternGlobalValue,
    createPattern: createPatternGlobal,
  },
  batch: {
    patternValue: patternBatchValue,
    createPattern: createPatternBatch,
  },
  document: {
    patternValue: patternDocumentValue,
    createPattern: createPatternDocument,
  },
};

export type { PatternAccessScope } from './_common.type';
export type { PatternValueSetsData } from './_pattern-type.type';

export default patternLogic;
